import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnDestroy, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { TaxonomyTreeToTextPipe } from 'shared/util-common';

import { BreadcrumbItem } from '@treetop/shared/model';

import { BreadcrumbService } from './breadcrumb.service';
import { IconDirective } from '../icon/icon.directive';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'tt-breadcrumb',
  standalone: true,
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [MatIconModule, IconDirective, TooltipDirective, TranslocoModule, TaxonomyTreeToTextPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BreadcrumbService],
})
export class BreadcrumbComponent implements AfterViewInit, OnDestroy {
  protected service = inject(BreadcrumbService);

  @Input()
  public set breadcrumb(breadcrumb: BreadcrumbItem[]) {
    this.service.setBreadcrumb(breadcrumb);
  }

  private resizeObserver: ResizeObserver;

  protected targetElement = viewChild<ElementRef<HTMLElement>>('breadcrumbItem');

  public ngAfterViewInit(): void {
    const targetElement = this.targetElement().nativeElement;

    if (targetElement) {
      const parentElement = targetElement.parentElement;
      const totalTextWidth = this.service.getTotalTextWidth(targetElement);
      this.service.calculateCollapse(totalTextWidth, parentElement);

      this.resizeObserver = new ResizeObserver(() => {
        this.service.calculateCollapse(totalTextWidth, parentElement);
      });

      this.resizeObserver.observe(parentElement);
    }
  }

  public ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
